import { LOAD_DISTRICTS } from "./actions";
import * as R from "ramda";
import _ from "lodash";

const initialState = { isLoading: false, selectedDistrict: {} };

const districts = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_DISTRICTS.REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case LOAD_DISTRICTS.SUCCESS: {
      const districtsPayload = R.path(["payload", "response", "entities", "districts"], action);
      const selectedDistrict = _.values(districtsPayload || {})[0];
      return {
        ...state,
        selectedDistrict,
        isLoading: false,
      };
    }
    case LOAD_DISTRICTS.FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default districts;
